import { DiskSpaceAlertComponent } from './../../components/disk-space-alert/disk-space-alert.component';
import { Component, ViewChild } from '@angular/core';
import { IonSlides, ModalController, NavParams, Platform } from '@ionic/angular';
import { Question, QuestionTypes } from '../../models/question.model';
import { PhotoVideoService } from '../../services/photo-video/photo-video.service';
import { Html5CanvasPage } from '../html5-canvas/html5-canvas.page';

@Component({
  selector: 'app-view-instructions',
  templateUrl: './view-instructions.page.html',
  styleUrls: ['./view-instructions.page.scss'],
})
export class ViewInstructionsPage {
  @ViewChild('slider') slides: IonSlides;
  @ViewChild('diskSpaceAlert') diskSpaceAlert: DiskSpaceAlertComponent;

  QuestionTypes = QuestionTypes;
  isFirstSlide: boolean;
  isLastSlide: boolean;
  question: Question = new Question();
  slideOpts;

  constructor(
    public modalCtrl: ModalController,
    public params: NavParams,
    public photoVideoService: PhotoVideoService,
    public platform: Platform
  ) {
    this.question = this.params.get('question');
    this.slideOpts = {
      initialSlide: 0,
      speed: 400,
      autoHeight: true,
    };
  }

  async ionViewDidEnter() {
    if (this.slides) {
      await this.slides.update();
      await this.doCheck();
    } else {
      this.isLastSlide = true;
    }
  }

  /* istanbul ignore next */
  actionBtn() {
    this.photoVideoService.openCameraPlugin(this.question);
    this.closeModal(true);
  }

  closeModal(cameraOpened?: boolean) {
    this.modalCtrl.dismiss({ cameraOpened });
  }

  swipeNext() {
    this.slides.slideNext();
  }

  swipePrevious() {
    this.slides.slidePrev();
  }

  async doCheck() {
    const prom1 = this.slides.isBeginning();
    const prom2 = this.slides.isEnd();
    await Promise.all([prom1, prom2]).then(data => {
      this.isFirstSlide = data[0];
      this.isLastSlide = data[1];
    });
  }

  async showCanvas() {
    this.modalCtrl.dismiss();
    const modal = await this.modalCtrl.create({
      component: Html5CanvasPage,
      componentProps: {
        question: this.question,
      },
      cssClass: 'html5-canvas-modal',
      swipeToClose: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }

  isLowDiskSpace() {
    return this.diskSpaceAlert?.show;
  }
}
